import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './css/CardSection.css';
import paymentLoginWidget from './cybergatewidget';
import { StyledEngineProvider } from '@mui/material/styles';

const Main = () => (
	<StyledEngineProvider injectFirst>
		<App />
	</StyledEngineProvider>
);

paymentLoginWidget().then(() => {
	var rootNode = document.getElementById('root');
	const root = createRoot(rootNode);
	root.render(<Main />);
});

/* if (module.hot) {
	module.hot.accept('./App', () => {
		const NextApp = require('./App').default;
		ReactDOM.render(<NextApp />, rootNode);
	});
} */
